const ICD10Strings = {
    SeverityMismatchError: "An ICD-10 code for Major Depressive Disorder (MDD) was not entered that matches the DSM-5 criteria selections for this patient. Please either enter a matching MDD ICD-10 code or change the DSM-5 criteria selections.",
    ICDMissing: "Please provide at least one ICD-10 code.",
    ICDMissingAtStart: "Please tap the textbox to provide the appropriate ICD-10 code."
};

module.exports = {
    ICD10Strings
};
